import { createFolder_favoritesPage, deleteFolder_favoritesPage, expandFolder, init_favFolder_dragDrop, remCampFromFolder_favoritesPage, showFavoritesFolder, unfavorite_campsite_remDisp } from "./util/favorite_campsite";
import Splide from '@splidejs/splide';

export function initFavSplide(){
	var elms = document.getElementsByClassName( 'splide' );
	for ( var i = 0; i < elms.length; i++ ) {
		new Splide( elms[i] as HTMLElement ).mount();
	};
}

if (window.location.pathname === "/bookmarks_folders") {
	$(".btn-remove-unfavorite-camp").each(function() {
		$(this).on("click", function() {
			unfavorite_campsite_remDisp(this);
		});
	});
	$("#remAllFavs").on("click", function() { 
		$(".btn-remove-unfavorite-camp").each(function() {
			unfavorite_campsite_remDisp(this);
		});
	});
	$("#createFolder").on("submit", (event) => createFolder_favoritesPage(event));
	
	$(document).on("click", ".expandFolder", function(this,event){expandFolder(this,event)})
	$("#favoritesFolderButt").on("click",()=>showFavoritesFolder());
	init_favFolder_dragDrop();

	$(document).on("click", ".btn-remove-camp-fromFolder", function(){remCampFromFolder_favoritesPage(this);});

	$(document).on("click", ".deleteFolder", function() {
		let folderID:number = parseInt($(this).attr("folder_id"));
		let folderEl:JQuery<HTMLElement> = $(`.folderIconWrap[folder_id=${folderID}]`);
		let folderName:string = folderEl.find(".foldername").html().toString();

		$("#deleteFolder_confirm").attr("folder_id", folderID);
		$("#deleteFolder_confirm_modal").find(".modal-title").html(`Delete ${folderName}?`);

		$("#deleteFolder_confirm_modal").modal("show");
	});

	$(document).on("click", "#deleteFolder_confirm", function() {
		let folderID:number = parseInt($(this).attr("folder_id"));
		let folderEl:JQuery<HTMLElement> = $(`.folderIconWrap[folder_id=${folderID}]`);
		deleteFolder_favoritesPage(folderEl,folderID);
	});
};